export const usePromise = (result) => {
  if (!result) return Promise.reject()
  return Promise.resolve(result)
}